// skuDisplay — shared display helpers for 品番ルール listings.
// Per user request 20260801: every SKU picker shows the 大分類 (first segment
// label + fixed value) as the main title, grouped by rule NAME.

export function skuMajorTitle(tpl) {
  const seg = (tpl?.segments || [])[0];
  const label = (seg?.label || '').trim();
  const value = seg?.kind === 'literal' ? String(seg.value ?? '').trim() : '';
  if (label && value && label !== value) return `${label} (${value})`;
  if (label) return label;
  if (value) return value;
  return tpl?.name || tpl?.code || '';
}

// 20260610 · 品番プレフィックス解決。第1リテラルセグメントの値（無ければ sample の
// 先頭英字）を採用する。採番ロジックは変更しない — 表示・可否判定のみに使う。
export function skuTemplatePrefix(tpl) {
  // §8.10 並びが 部署/種類（ENG/EQP00001 · IT/CSM00001）なら、番号を刻むのは
  // 後ろの 種類（共通採番の系列）。部署ラベルは番号の一部ではないので、先頭だけを
  // 見ると共通採番のロックをすり抜けてしまう（正本は backend/ledger_counters.py）。
  const literals = (tpl?.segments || [])
    .filter((s) => s?.kind === 'literal')
    .map((s) => String(s.value ?? ''))
    .join('');
  const shared = (literals || String(tpl?.sample || '')).match(/^[A-Za-z]{1,8}\s*\/\s*(EQP|CSM|FAB)/i);
  if (shared) return shared[1].toUpperCase();
  const literal = (tpl?.segments || [])
    .find((s) => s?.kind === 'literal' && String(s.value ?? '').trim());
  const raw = literal ? String(literal.value).trim() : String(tpl?.sample || '').trim();
  const m = raw.match(/^([A-Za-z]{2,6})/);
  return m ? m[1].toUpperCase() : '';
}

// 設備台帳など「台帳が自前のカウンターで採番する」プレフィックスの一覧は
// バックエンドが正本（`backend/ledger_counters.py` → GET /api/sku/ledger-counters）。
// ここには持たない — フロントに複製すると台帳が増えた時にドリフトする。
// 判定は `lib/ledgerPrefixes.js::ledgerLockFor` を使う。

export function groupTemplatesByName(templates) {
  const map = new Map();
  for (const t of templates || []) {
    const key = (t.name || t.code || '').trim();
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(t);
  }
  return [...map.entries()]
    .map(([name, items]) => ({ name, items }))
    .sort((a, b) => a.name.localeCompare(b.name, 'ja'));
}
